import JSConfetti from 'js-confetti'

export class ConfettiPresenter {
  jsConfetti = new JSConfetti()

  runConfetti = () => {
    this.jsConfetti.addConfetti({
      confettiColors: [
        'DodgerBlue',
        'OliveDrab',
        'Gold',
        'pink',
        'SlateBlue',
        'lightblue',
        'Violet',
        'PaleGreen',
        'SteelBlue',
        'SandyBrown',
        'Chocolate',
        'Crimson'
      ]
    })
  }
}
